import { useEffect, useRef, useState } from 'react';
import ThemeContext from '../../context/ThemeContext';
import {
  Card, Title, Title2, Description,
  Duration, TagsList, Tag, LinkButton
} from './style.js';

const TimelineCard = ({ details }) => {
  const [isVisible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <ThemeContext.Consumer>
      {value => (
        <Card ref={ref} theme={value.theme} className={isVisible ? 'visible' : ''}>
          <Title theme={value.theme}>{details.courseTitle}</Title>
          <Title2 theme={value.theme}>{details.at}</Title2>
          <Description theme={value.theme}>{details.description}</Description>
          <Duration theme={value.theme}>Duration: {details.duration}</Duration>
          {details.tagsList && (
            <TagsList>
              {details.tagsList.map(tag => (
                <Tag key={tag.id}>{tag.name}</Tag>
              ))}
            </TagsList>
          )}
          {details.website && (
            <LinkButton href={details.website} target="_blank" rel="noreferrer">
              Visit Site
            </LinkButton>
          )}
        </Card>
      )}
    </ThemeContext.Consumer>
  );
};

export default TimelineCard;
